<template>  
    <div class="popu-view" v-show="show">
        <transition name="el-fade-in-linear"> 
                <div class="mask" v-if="mask"></div>
        </transition>
        <transition name="el-fade-in-linear"> 
            <div :class="['main-view',backImg]"
                :style="{width:`${width}px`,height:`${height}px`}"    
                v-show="show"
            >
                <div class="login-close" @click="close">
                    <img src="@/assets/login_close_up.png" alt="" class="up">
                    <img src="@/assets/login_close_down.png" alt="" class="down"> 
                </div>
                <div class="popu-title">{{title}}</div>
                <div class="content-view">
                    <slot name="content"></slot>
                </div>
            </div> 
        </transition>
    </div> 
</template>
<script> 
export default {
  props:{
      show:{
          type:Boolean,
          default:false
      },
      mask:{
          type:Boolean,
          default:false
      },
      width:{
          type:String,
          default:"580" //580 640
      },
      height:{
          type:String,
          default:"420" //420 460
      },
      title:{
          type:String,
          default:"用户登录"
      },
      backImg:{
        type: String,
        default: "login"
      }
  },
  data() {
    return { 
    };
  },
  watch:{
      show(){ 
        //   if(this.show){ 
        //       document.getElementsByTagName('html')[0].style.height = '100%'; 
        //       document.getElementsByTagName('html')[0].style.overflow= 'hidden';
        //   }else{
        //       document.getElementsByTagName('html')[0].style.height = 'auto'; 
        //       document.getElementsByTagName('html')[0].style.overflow= 'auto';
        //   }
      }
  },
  computed: {
  }, 
  methods: { 
      close(){
          this.$emit("close",{})
      }
  },
  mounted() {
  }
};
</script>
<style scoped lang="less">
.popu-view{
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    .mask{
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        position: fixed;
        background: rgba( 255,255,255,.3);
    }
    .main-view{ 
        background-size: cover;
        background-position: center;
        position: fixed;
        z-index: 6;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);

        .login-close{
            width: 60px;
            position: absolute;
            top: 0;
            right: 0;
            cursor: pointer;
            
            img{
                width: 100%;
            }

            .up,.down{
                position: absolute;
                top: 0;
                left: 0; 
            }
            .up{
                z-index: 3;
                &:hover{
                    z-index: 1;
                }
            }
            .down{
                z-index: 2;
                &:hover{
                    z-index: 4;
                }
            }
        }

        .popu-title{
            text-align: center;
            color: #3a3a3a;
            font-size: 18px;
            padding: 5px 0 0 0;
            font-weight: 800;
        }

        .content-view{
            padding: 0 30px 0 30px;
        }

    }

}   
.login{
    background-image: url("../assets/loginframe.png");
}
.serach{
    background-image: url("../assets/search_pop_bg.png");
}

</style>
